module.exports = __webpack_public_path__ + "img/medal-gold.e7fd888c.png";